import { IDocumentTracking } from '../types/document-tracking';
export interface ITrackingState {
  loading: boolean;
  loaded: boolean;
  tracking: IDocumentTracking;
  selectedRecipientId: string;
}

export enum ETrackingAction {
  Load = 'loadTracking',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',
  Reset = 'reset',
  SelectRecipientId = 'selectRecipientId',
  ResetSelectedRecipientId = 'resetSelectedRecipientId',
  AddClickTracking = 'addClickTracking',
  AddVideoTracking = 'addVideoTracking',
  AddPageTracking = 'addPageTracking',
  AddVisitTimeTracking = 'addVisitTimeTracking',
}

export enum ETrackingMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetTracking = 'setTracking',
  SetState = 'setState',
  SetSelectedRecipientId = 'setSelectedRecipientId',
  AddClickTracking = 'addClickTracking',
  AddVideoTracking = 'addVideoTracking',
  SetPageTrackings = 'setPageTrackings',
  AddVisitTimeTracking = 'addVisitTimeTracking',
}
